var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 18 20",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.599 0h4.173c.579 0 1.044.465 1.044 1.043v8.697h4.513c.93 0 1.396 1.122.74 1.783l-7.644 7.652c-.41.409-1.07.409-1.479 0l-7.639-7.653c-.656-.657-.191-1.783.74-1.783h4.508v-8.696c0-.578.465-1.043 1.044-1.043z",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDown);
export default __webpack_public_path__ + "static/media/icn_down.a20db34eb8f88ff9963c3f87c68cd486.svg";
export { ForwardRef as ReactComponent };